import "./BNR_Cogniitec.css";
import React from "react";
import { useState } from "react";
import BannerSlider from "./Magic_slider";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";
import { useLocation } from "react-router-dom";

function BNR_Cogniitec_LP() {
  const location = useLocation(); // Get the current location (path)

  const meta = metaConfig.bnrcogniitec;
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <SEO {...meta} />

      <div className="bnr_mainwrap">
        <div className="container-fluid  position-relative p-0">
          <div className="bnrbrnad mt-0">
            <div className="col-11 mx-auto item-align-end">
              <nav className="navbar">
                <div className="logo">
                  <a href="https://cogniitec.com/" className="p-0">
                    <img
                      src="assets/img/Bnrcogniitecimg/bnrlogo.png"
                      alt="BNR Cogniitec"
                    />
                  </a>
                </div>

                <ul className={`nav-links ${isOpen ? "open" : ""}`}>
                  <li>
                    <a href="https://cogniitec.com/">Home</a>
                  </li>
                  <li>
                    <a href="https://cogniitec.com/">About</a>
                  </li>
                  <li>
                    <a href="https://cogniitec.com/">Services</a>
                  </li>
                  <li>
                    <a href="https://cogniitec.com/contact-us/">Contact</a>
                  </li>
                </ul>
                <div className="portfolio">
                  <a href="https://cogniitec.com/portfolio/" className="p-0">
                    Portfolio
                  </a>
                </div>
                <div className="menu-toggle" onClick={toggleMenu}>
                  <span className="bar"></span>
                  <span className="bar"></span>
                  <span className="bar"></span>
                </div>
              </nav>
            </div>
          </div>

          {/* <!-- Carousel Start --> */}
          <div className=" bnr_lp_wrap">
            <BannerSlider />
          </div>
        </div>

        {/* <!-- Carousel End --> */}

        <div className="container-fluid bnr_pageicons py-5">
          <div className="container ">
            <div className="text-left pb-2 wow fadeInUp" data-wow-delay="0.2s">
              <div
                className="col-xl-6 brand_titlewrap d-flex wow fadeInUp"
                data-wow-delay="0.2s"
              >
                {" "}
                <h1 className="brandname">Cogniitec</h1>
                <p className="breakwords wow fadeInDown" data-wow-delay="0.2s">
                  Your Partner in <br />
                  Digital Transformation <br />
                  and Innovation
                </p>
              </div>
            </div>

            <div className="row bnr_lp_content g-4">
              <div
                className="text-left mx-auto pt-0 mt-0 wow fadeInUp"
                data-wow-delay="0.2s"
              >
                <div className="col-md-8 pt-0 col-md-12 d-flex m-auto">
                  <hr></hr>
                </div>

                <p className="mb-3">
                  BNR Cogniitec Private Limited is a leading technology
                  solutions provider offering a comprehensive range of services
                  designed to meet the evolving needs of businesses in today's
                  digital landscape. Our expertise spans various areas,
                  including software development, data analytics, cloud
                  computing, and IT consulting. We leverage the latest
                  technologies and best practices to deliver innovative and
                  cost-effective solutions that help our clients achieve their
                  business goals. We are committed to delivering exceptional
                  quality and exceeding client expectations.
                </p>

                <p className="mb-3">
                  We work closely with our clients to understand their unique
                  challenges and develop tailored solutions that address their
                  specific needs. Our experienced team of professionals
                  possesses a deep understanding of the technology landscape and
                  a commitment to delivering results. We follow a collaborative
                  approach, working in partnership with our clients throughout
                  the entire project lifecycle, ensuring transparency and open
                  communication. Our agile methodology allows for flexibility
                  and responsiveness to evolving requirements.
                </p>
                <p className="mb-0">
                  At BNR Cogniitec, we believe in fostering long-term
                  partnerships built on trust and mutual success. Our dedication
                  to innovation and continuous improvement ensures that we
                  remain at the forefront of technological advancements. We are
                  committed to providing cutting-edge solutions that enable our
                  clients to stay ahead of the competition and achieve lasting
                  growth. We are proud of our track record of success and our
                  commitment to delivering exceptional value to our clients.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- feature Start --> */}

        <div className="container-fluid bnr_feature ">
          <div className="container bnr_brna_feat pb-5">
            <div
              className="text-center mx-auto  wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <h3 className="display-3 brandname text-capitalize mb-5">
                Innovative Technology Solutions Transforming the Future
              </h3>
            </div>
            <div className="row g-4 pb-5 mb-5">
              <div className=" col-md-6 col-lg-6 col-xl-4 ">
                <div className="border_gradient p-4">
                  <div className="d-flex">
                    <div className="pe-3">
                      <div className="service-btn">
                        <img
                          className="w-100 d-flex mx-auto"
                          src="assets/img/Bnrcogniitecimg/freature-1.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div>
                      <a
                        href="https://cogniitec.com/"
                        className="h5 d-inline-block mb-2"
                      >
                        Python
                      </a>
                      <p className="mb-0 truncated-text">
                        Python powers everything from web development to data
                        science and machine learning with its vast libraries and
                        applications.
                      </p>
                      <a
                        href="https://cogniitec.com/"
                        class="brandname clickmore "
                      >
                        View More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" col-md-6 col-lg-6 col-xl-4 ">
                <div className="border_gradient p-4">
                  <div className="d-flex">
                    <div className="pe-3">
                      <div className="service-btn">
                        <img
                          className="w-100 d-flex mx-auto"
                          src="assets/img/Bnrcogniitecimg/freature-2.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div>
                      <a
                        href="https://cogniitec.com/"
                        className="h5 d-inline-block mb-2"
                      >
                        React Native
                      </a>
                      <p className="mb-0 truncated-text">
                        React Native is a powerful framework for building
                        cross-platform mobile apps using a single codebase,
                        blending efficiency with flexibility.
                      </p>
                      <a
                        href="https://cogniitec.com/"
                        class="brandname clickmore "
                      >
                        View More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" col-md-6 col-lg-6 col-xl-4 ">
                <div className="border_gradient p-4">
                  <div className="d-flex">
                    <div className="pe-3">
                      <div className="service-btn">
                        <img
                          className="w-100 d-flex mx-auto"
                          src="assets/img/Bnrcogniitecimg/freature-3.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div>
                      <a
                        href="https://cogniitec.com/"
                        className="h5 d-inline-block mb-2"
                      >
                        Java
                      </a>
                      <p className="mb-0 truncated-text">
                        Java is used to power everything from simple phone apps
                        to complex business systems. It is strong and compatible
                        with different devices, making it a great choice for all
                        sorts of projects.
                      </p>
                      <a
                        href="https://cogniitec.com/"
                        class="brandname clickmore "
                      >
                        View More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" col-md-6 col-lg-6 col-xl-4 ">
                <div className="border_gradient p-4">
                  <div className="d-flex">
                    <div className="pe-3">
                      <div className="service-btn">
                        <img
                          className="w-100 d-flex mx-auto"
                          src="assets/img/Bnrcogniitecimg/freature-4.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div>
                      <a
                        href="https://cogniitec.com/"
                        className="h5 d-inline-block mb-2"
                      >
                        Machine Learning
                      </a>
                      <p className="mb-0 truncated-text">
                        Machine learning helps computers to learn and improve,
                        just like humans! This lets them build smarter apps that
                        can find patterns, make predictions, and help you make
                        better decisions.
                      </p>
                      <a
                        href="https://cogniitec.com/"
                        class="brandname clickmore "
                      >
                        View More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-6 col-xl-4 ">
                <div className="border_gradient p-4">
                  <div className="d-flex">
                    <div className="pe-3">
                      <div className="service-btn">
                        <img
                          className="w-100 d-flex mx-auto"
                          src="assets/img/Bnrcogniitecimg/freature-5.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div>
                      <a
                        href="https://cogniitec.com/"
                        className="h5 d-inline-block mb-2"
                      >
                        Flutter
                      </a>
                      <p className="mb-0 truncated-text">
                        Flutter creates stunning, high-performance applications
                        compatible with all devices—phones, tablets, and
                        computers alike. With Flutter, apps are visually
                        impressive and operate seamlessly.
                      </p>
                      <a
                        href="https://cogniitec.com/"
                        class="brandname clickmore "
                      >
                        View More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-6 col-xl-4 ">
                <div className="border_gradient p-4">
                  <div className="d-flex">
                    <div className="pe-3">
                      <div className="service-btn">
                        <img
                          className="w-100 d-flex mx-auto"
                          src="assets/img/Bnrcogniitecimg/freature-6.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div>
                      <a
                        href="https://cogniitec.com/"
                        className="h5 d-inline-block mb-2"
                      >
                        Android
                      </a>
                      <p className="mb-0 truncated-text">
                        Android is a smartphone operating system, that guides
                        billions of devices globally. It is renowned for
                        allowing users to personalize their phones and tap into
                        an extensive app library.
                      </p>
                      <a
                        href="https://cogniitec.com/"
                        class="brandname clickmore "
                      >
                        View More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- feature End --> */}

        <div className="container-fluid blueboxtext ">
          <div className="container bnr_brna_feat">
            <div
              className="text-center mx-auto  wow fadeInUp"
              data-wow-delay="0.2s"
            ></div>
            <div className="row g-4">
              <div className=" col-md-4 col-lg-4p-0 m-0 col-xl-4 ">
                <div className="border_circle p-4">
                  <div className="d-flex">
                    <div>
                      <p className="m-0 p-4">
                        Our customer focussed approach and innovative strategy
                        enables businesses to stand out from other competitors.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" col-md-8 col-lg-8 p-0 m-0 col-xl-8 ">
                <div className="border_circel_details p-4">
                  <div className="d-flex">
                    <div>
                      <p className="h5 text-left h4 mb-0">
                        Experience the power of expertise. Connect with
                        Cogniitec today. or Your vision, realized. Discover how
                        Cogniitec can help. or Driving digital growth through
                        innovative solutions
                      </p>
                      <a
                        href="https://cogniitec.com/contact-us/"
                        className=" d-inline-block btn btn-primary rounded-pill mt-2"
                      >
                        Contact us
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid bnr_pageicons bnr_tech_solution  py-5">
          <div className="container mt-5">
            <div
              className="text-center pb-3 wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <div
                className=" d-flex text-center wow fadeInUp"
                data-wow-delay="0.2s"
              >
                <h3 className="brandname display-3 m-auto  ">
                  Transform Your Business with Trending Technologies
                </h3>
              </div>
            </div>

            <div className="row bnr_lp_content g-4">
              <div
                className="text-left mx-auto wow fadeInUp"
                data-wow-delay="0.2s"
              >
                <p className="mb-3">
                  BNR Cogniitec Private Limited is a leading technology
                  solutions provider offering a comprehensive range of services
                  designed to meet the evolving needs of businesses in today's
                  digital landscape. Our expertise spans various areas,
                  including software development, data analytics, cloud
                  computing, and IT consulting. We leverage the latest
                  technologies and best practices to deliver innovative and
                  cost-effective solutions that help our clients achieve their
                  business goals. We are committed to delivering exceptional
                  quality and exceeding client expectations.
                </p>
              </div>

              <div
                className="text-left small_icons ms-auto wow fadeInUp"
                data-wow-delay="0.2s"
              >
                <div
                  className="  col-xl-2 border_gradient m-auto d-inline-block wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <div className="feature-item   text-center p-4">
                    <div className="feature-icon mb-3">
                      <img
                        src="assets/img/Bnrcogniitecimg/microsoft.png"
                        alt=""
                      />
                    </div>
                    <span className="h4 ">Share Point</span>
                    <a
                      href="https://cogniitec.com/"
                      className="brandname clickmore "
                    >
                      View More
                    </a>
                  </div>
                </div>
                <div
                  className=" col-xl-2 border_gradient m-auto d-inline-block wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <div className="feature-item   text-center p-4">
                    <div className="feature-icon mb-3">
                      <img src="assets/img/Bnrcogniitecimg/go.png" alt="" />
                    </div>
                    <span className="h4 ">Golang</span>
                    <a
                      href="https://cogniitec.com/"
                      className="brandname clickmore "
                    >
                      View More
                    </a>
                  </div>
                </div>
                <div
                  className="col-xl-2 border_gradient m-auto d-inline-block  wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <div className="feature-item  text-center p-4">
                    <div className="feature-icon m-auto mb-3">
                      <img src="assets/img/Bnrcogniitecimg/w3.png" alt="" />
                    </div>
                    <span className="h4 ">Data Engineer</span>
                    <a
                      href="https://cogniitec.com/"
                      className="brandname clickmore "
                    >
                      View More
                    </a>
                  </div>
                </div>
                <div
                  className="col-xl-2 border_gradient m-auto d-inline-block  wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <div className="feature-item  text-center p-4">
                    <div className="feature-icon m-auto mb-3">
                      <img src="assets/img/Bnrcogniitecimg/object.png" alt="" />
                    </div>
                    <span className="h4 ">Web 3</span>
                    <a
                      href="https://cogniitec.com/"
                      className="brandname clickmore "
                    >
                      View More
                    </a>
                  </div>
                </div>
                <div
                  className="col-xl-2 border_gradient m-auto d-inline-block  wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <div className="feature-item text-center p-4">
                    <div className="feature-icon m-auto mb-3">
                      <img src="assets/img/Bnrcogniitecimg/ds.png" alt="" />
                    </div>
                    <span className="h4 ">Data Science</span>
                    <a
                      href="https://cogniitec.com/"
                      className="brandname clickmore "
                    >
                      View More
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="text-center bottom_cta mx-auto  wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <h3 className="h3 py-5">
                you can contact easily at +91 91592 80746 or send <br />
                email to support@gmail.com
              </h3>
              <a
                href="https://cogniitec.com/contact-us/"
                className="btn-grad btn  d-inline-block"
              >
                {" "}
                Contact Us
              </a>
            </div>
          </div>
        </div>

        <div className="container-fluid mt-5 bnr_lp-footer">
          <div className="container">
            <div className="row bnr_lp_content g-4">
              <div
                className="text-left small_icons ms-auto wow fadeInUp"
                data-wow-delay="0.2s"
              >
                <div
                  className="col-xl-12 m-auto d-flex wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <div
                    className="col-xl-3 d-inline-block wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <div className="feature-item  text-left p-4">
                      <h5 className="h5 text-white d-inline-block mb-2">
                        Corporate Office
                      </h5>
                      <p>
                        33B, New No 64th street, 1st floor, opposite to Kovai
                        Scan Center,Tatabad, Coimbatore - 641012.
                      </p>
                    </div>
                  </div>
                  <div
                    className="  col-xl-3 d-inline-block wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <div className="feature-item  text-left p-4">
                      <h5 className="h5 text-white d-inline-block mb-2">
                        Reach Us
                      </h5>
                      <p>
                        33B, New No 64th street, 1st floor, opposite to Kovai
                        Scan Center,Tatabad, Coimbatore - 641012.
                      </p>
                    </div>
                  </div>
                  <div
                    className="  col-xl-3 d-inline-block wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <div className="feature-item  text-left p-4">
                      <h5 className="h5 text-white d-inline-block mb-2">
                        Call Us
                      </h5>
                      <p className="m-0">0422 2526255 </p>
                      <p className="m-0">+91 9159280746</p>
                      <p className="m-0">+91 6380750902</p>
                    </div>
                  </div>
                  <div
                    className="  col-xl-3 d-inline-block wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <div className="feature-item  text-left p-4">
                      <h5 className="h5 text-white d-inline-block mb-2">
                        Mail Us
                      </h5>
                      <p className="m-0">
                        <a
                          href="mailto:support@gmail.com"
                          className="text-decoration-underline"
                        >
                          support@gmail.com
                        </a>
                      </p>
                      <p>
                        <a
                          href="mailto: cogniitec@gmail.com"
                          className="text-decoration-underline"
                        >
                          cogniitec@gmail.com
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row copyright m-0 p-0 align-items-end">
            <div className="col-md-12 text-center text-md-end mb-md-0">
              <span className="text-body">
                <a
                  href="https://cogniitec.com/"
                  target="_blank"
                  className="border-none"
                >
                  <i className="fas fa-copyright me-2"></i>BNR Cogniitec Pvt Ltd
                </a>
                , All right reserved.
              </span>
            </div>
          </div>
        </div>
        <button
          className="btn btn-secondary btn-lg-square rounded-circle back-to-top"
          onClick={() => window.scrollTo(0, 0)}
        >
          <i className="fa fa-arrow-up"></i>
        </button>
      </div>
    </div>
  );
}

export default BNR_Cogniitec_LP;
